module.exports = __webpack_public_path__ + "static/media/webpack.5b1f36bc.png";